import { NodeProps } from "reactflow";
import NodeCard from "../NodeCard";
import {
  FlowModuleItemType,
  // ModuleInputKeyEnum,
  // VariableItemType,
} from "@packages/flow-core/module";
import { Divider as AntDivider } from "antd";
import styles from "./index.less";
import { memo, useMemo } from "react";
// import VariableEdit from '../VariableEdit';
// import { useFlow } from '@/components/FlowEdit/useFlow';
import RenderInput from "../render/RenderInput";
import Divider from "../Divider";
import RenderOutput from "../render/RenderOutput";

// function ChatStartVariable({ data }: { data: FlowModuleItemType }) {
//   const { inputs, moduleId } = data;
//   const { updateNodeValue } = useFlow();
//   const variableNode = useMemo(() => {
//     return inputs.find((item) => item.key === ModuleInputKeyEnum.variables);
//   }, [inputs]);

//   const variables = useMemo(() => {
//     return (variableNode?.value as VariableItemType[]) || [];
//   }, [variableNode]);

//   return (
//     <VariableEdit
//       value={variables}
//       onChange={(data) => {
//         updateNodeValue(moduleId, variableNode!.key, data);
//       }}
//     />
//   );
// }

export default memo(function NodeGlobalVariable(
  props: NodeProps<FlowModuleItemType>
) {
  const { data, selected } = props;
  const normalInput = useMemo(() => {
    return props.data.inputs.filter((input) => !input.edit);
  }, [data.inputs]);
  const customInput = useMemo(() => {
    return data.inputs.filter((item) => item.edit);
  }, [data.inputs]);
  return (
    <NodeCard {...data} selected={selected}>
      <AntDivider style={{ margin: 0 }} />
      <div className={styles.content}>
        <RenderInput moduleId={data.moduleId} flowInputList={normalInput} />
        <RenderInput moduleId={data.moduleId} flowInputList={customInput} />
        {/* <ChatStartVariable data={data} /> */}
      </div>
      {!!data.outputs && data.outputs.length > 0 && (
        <>
          <Divider text="输出" />
          <div className={styles.content}>
            <RenderOutput
              flowOutputList={data.outputs}
              moduleId={data.moduleId}
            />
          </div>
        </>
      )}
    </NodeCard>
  );
});
